var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.user)?_c('UserEdit',{attrs:{"userId":_vm.user}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }